<template>
  <div class="box scroll-item chat-list">
    <div class="toPrint" @click="toPrintPage">
      <div class="flex" v-if="userInfo.id">
          <img src="../../assets/images/wap/show.png" alt="">
          
      </div>
      
    </div>
    <div class="item" v-for="(item,i) in printList" :key="i">
      <div class="top">
        <img class="avatar" src="../../assets/images/wap/avatar.png" alt="">
          <span>{{item.name}}</span>
      </div>
      <span class="times">{{ item.timeDescribe }}</span>
      <div class="content">
        <span class="name">{{ item.content||'' }}</span>
    
      </div>
       <div class="flex">
        <div v-for="(items, index) in item.imgUrls" :key="index" >
        <img :src="items" alt="" class="imgs">
       </div>
       </div>
      <div class="bottoms">
        <span class="type"></span>
        <div class="like" @click="addLIke(item)">
          <img src="../../assets/images/gifts/like.png" alt="">
          <span>{{ item.encouragements }}</span>
        </div>
      </div>
    </div>
    <div v-if="!printList.length" class="nodata">暂无晒单记录</div>
  </div>
</template>

<script>
import { GetPrintOutViewPage,SetPrintOut} from '../../api/home'
export default {
  name:'handouts',
  data(){
   return{
     printList:[
       
    ]
   }
  },
  computed:{
    // 个人信息
        userInfo() {
            return this.$store.state.login.userInfo
        },
    teacherInfo(){
      return this.$store.state.home.teacherInfo
    },
    bnotes(){
      return this.$store.state.home.bnotes
    },
    roomInfo() {
      return this.$store.state.home.roomInfo
    },
  },
  created(){
    // 初始化课堂笔记
    this.getBnotes();
    this.getLists()//获取晒单列表
  },
  mounted(){
  },
  methods:{
    // craig--获取课堂笔记列表
    async getBnotes(){
      const option = {
        // broomid:this.roomInfo.id,
        broomid:this.roomInfo.id,
        // tid:this.teacherInfo[1].id,
        // bsheetid:this.teacherInfo[0].value.id,
        // bsheetid:this.teacherInfo[0].value.id,
        sort:'ut,DESC',
      }
      await this.$store.dispatch('home/getBnotes',option)
    },
    //获取晒单列表
     getLists(){
      const option = {
        // broomid:this.roomInfo.id,
        // broomid:this.roomInfo.id,
        // tid:this.teacherInfo[1].id,
        // bsheetid:this.teacherInfo[0].value.id,
        // bsheetid:this.teacherInfo[0].value.id,
        // sort:'ut,DESC',
        
         "businessPlatform":4,"questionType":3,"isPublic":true,"maxResultCount":20,"skipCount":0
      }
      GetPrintOutViewPage(option).then(res=>{
        console.log('晒单数据----------',res)
        if(res.error ==null){
          this.printList=res.result.items
          // if(res.result.item.length>1){
            
          //   // this.swiperData = res.Data;
          //   // this.onceOrmore = true;
          // }else{
          //   // this.imgData = res.Data[0];
          //   // this.onceOrmore = false;
          // }
        }
      }).catch(err=>{
        console.log(err);
      })
      // await this.$store.dispatch('home/getLists',option)
    },
    addLIke(e){
      const option={
         "businessPlatform": 4,
        "account": this.userInfo.mtaccr,
         "name": e.name,
         "printOutId": e.id
      }
      SetPrintOut(option).then(res=>{
        console.log('dianzna',res)
        if (res.result.code===0){
           this.$message({
             message: res.result.message,
            type: "success",
          });
          this.getLists()
        }else{
           this.$message({
             message: res.result.message,
            type: "error",
          });
        }
      })

    },
    // 时间戳转时间
    timestampToTime(timestamp) {
      let date = new Date(parseInt(timestamp));
      let Year = date.getFullYear();
      let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
      let Hour = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      let Minute = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      let Sechond = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Year + '-' + Moth + '-' + Day + ' ' + Hour +':'+ Minute  + ':' + Sechond;
    },

    // 跳转我的晒单
    toPrintPage(){
      // this.$store.commit('home/set_showtoPrint', true)

      this.$router.push({
      name: 'printOut',
      })
    }
  },
}
</script>

<style lang="less" scoped>
  .box{
    width: 100%;
    height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding-top: 25px;
    position: relative;
    .item{
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-bottom: 10px;
      box-sizing: border-box;
      position: relative;
      .top{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        img{
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 10px;
        }
        p{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          span{
            color: #b3b3b3;
            font-size: 13px;
            margin: 2px 5px 2px 0;
          }
        }
        span{
          font-size: 14px;
          line-height: 20px;
          color: #333;
        }
      }
      .content{
        font-size: 13px;
        color: #333;
        line-height: 18px;
        .name{
          font-weight: 600;
        }
        margin: 16px 0 8px 0;
      }
      .flex{
        display: flex;
        align-items: center;
      }
      .imgs{
        width: 124px;
        height: 86px;
        border: 1px solid #EDEDED;
        border-radius: 10px;
        margin-right: 12px;
      }
      .times{
        color: #666666;
        font-size: 11px;
        line-height: 15px;
        position: absolute;
        top: 0;
        right: 0;

      }
      .bottom{
        background-color: #fff;
        padding: 10px;
        text-align: justify;
        font-size: 14px;
        border-radius: 5px;
        white-space: pre-wrap;
      }
      .bottoms{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .type{
        width: 84px;
        height: 25px;
        // background: #FFF7E9;
        border-radius: 4px;
        // color: #D79B00;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        line-height: 25px;
      }
      .like{
        font-size: 14px;
        line-height: 17px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }
      }
    }
    .nodata {
      font-size: 14px;
      color: #8c99a5;
      padding: 10px;
      text-align: center;
    }
    .toPrint{
      position: fixed;
      right: 0;
      top: 60%;
      z-index: 10;
      img{
        width: 70px;
        height: 70px;
      }
      .tos{
        width: 52px;
        height: 21px;
        border-radius: 13px;
        background: linear-gradient(90deg, #1E2C84 6.28%, #2C3FB9 77.38%);
           display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 17px;
        font-weight: 500;
        color: #fff;
        position: absolute;
        bottom: 0;
        left: 10px;
      }
      .flex{
        position: relative;
     
      }
    }
  }
  .scroll-item::-webkit-scrollbar{
    width: 2px;
  }
  .scroll-item::-webkit-scrollbar-thumb {
    background-color: #fb5c76;
    border-radius: 2em;
  }
  .scroll-item::-webkit-scrollbar-track {
    background-color: #b6bfc2;
    border-radius: 2em;
  }
  @media screen and (max-width: 500px) {
    .box{
      width: 100%;
      height: 450px;
      .item{
        .bottom{
          background-color: #f7f8fa;
        }
      }
    }
  }
</style>